import gql from 'graphql-tag'

export const LOGIN = gql`
  mutation TokenAuth($email: String!, $password: String!) {
    tokenAuth(email: $email, password: $password) {
      token
      refreshToken
      user {
        id
        email
        displayName
        isStaff
      }
    }
  }
`

export const REGISTER = gql`
  mutation Register($email: String!, $password: String!, $displayName: String) {
    register(email: $email, password: $password, displayName: $displayName) {
      token
      refreshToken
      user {
        id
        email
        displayName
        isStaff
      }
    }
  }
`

export const GOOGLE_AUTH = gql`
  mutation GoogleAuth($idToken: String!) {
    googleAuth(idToken: $idToken) {
      token
      refreshToken
      user {
        id
        email
        displayName
        isStaff
      }
    }
  }
`

export const ME = gql`
  query Me {
    me {
      id
      email
      displayName
      isStaff
    }
  }
`

export const ADMINS_QUERY = gql`
  query Admins {
    admins {
      id
      email
      displayName
      dateJoined
      isSuperuser
    }
  }
`

export const USERS_QUERY = gql`
  query Users($count: Int, $offset: Int, $search: String, $orderBy: String) {
    users(count: $count, offset: $offset, search: $search, orderBy: $orderBy) {
      totalCount
      items {
        id
        email
        displayName
        dateJoined
        isStaff
        isSuperuser
      }
    }
  }
`

